<template>
  <div class="sharing-stream-section">
    <b-modal ref="modal" id="shareStream"
              v-model="showBaseModal"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close>
        <!-- Modal Content Section -->
		<div slot="modal-header">
			<div class="icon-share2"></div>
			<div class="title">Stream Sharing</div>
		</div>
        <div class="stream-detail">
          <span class="entity-label"> {{entityLabel}} Name: </span>
		  <span class="entity-title">{{formattedSharedEntity.title}}</span>
        </div>
		<div class="stream-detail">
          <span class="entity-label"> {{entityLabel}} Link:</span>
		  <span class="entity-title">{{shareLink}}</span>
        </div>
        <div class="sharing-detail-container">
           {{sharingTextHeader}}
        </div>
		<div class="tabel-container">
			<b-table hover :items="formattedSharedWithUsers" :fields='baseModalTableFields'>
			  <template slot="permission" slot-scope="data">
				<b-form-group v-if="data.item.isEditing">
				  <input @change="readClicked(data.item)" v-model="data.item.isRead" type="checkbox" name="readCheckBox" value="read" aria-label="ready">read</input><br>
				  <input @change="writeClicked(data.item)" v-model="data.item.isWrite" type="checkbox" name="writeCheckBox" value="write" aria-label="write">write</input><br>
				  <input @change="shareClicked(data.item)" v-model="data.item.isShare" type="checkbox" name="shareCheckBox" value="share" aria-label="share">share</input><br>
				  <b-btn @click="isDoneEditingUser(data.item)" aria-label="ok">Ok</b-btn>
				</b-form-group>
				<a v-else @click.prevent="isEditingUser(data.item)">{{data.item.sharePermission}}
				</a>
			  </template>
			<template slot="remove" slot-scope="data">
			  <b-button @click.stop='removeUser(data.item)' aria-label="remove user">X</b-button>
			</template>
		  </b-table>
		</div>
        <b-button-group>
          <b-btn @click="showChoosePeopleClicked" aria-label="choose people">
            choose people
          </b-btn>
          <!-- NOTE: not migrating choose groups for now -->
          <!-- <b-btn @click="showChooseGroupsModal = true">
            choose groups
          </b-btn> -->
        </b-button-group>
        <!-- Modal Footer Section -->
        <div slot="modal-footer">
          <b-button-group>
            <b-btn @click="cancelClicked" aria-label="cancel">
              cancel
            </b-btn>
            <b-btn @click="saveAndDoneClicked" aria-label="save and done">
              save and done
            </b-btn>
          </b-button-group>
        </div>
      </b-modal>
      <!-- Select People Modal -->
      <b-modal ref="modal"
                v-model="showChoosePeopleModal"
                no-close-on-esc
                no-close-on-backdrop
                hide-header-close>
          <!-- Modal Content Section -->
		  <div slot="modal-header">
			<div class="icon-share2"></div>
			<div class="title">Select People</div>
		</div>
          <div class="user-management-section">
      			<div class="page_subheading">
      				<div class="col-5" style="padding-left: 0px;">
      					<div class="search_field">
      						<input v-model="name" placeholder="search by name" aria-label="search by name" @input="resetNumber" style="float: left;">

      						<div class="clear-btn" v-if="this.name.length > 0" @click="loadUserList">
      							<b-btn @click="name = ''" aria-label="clear">X</b-btn>
      						</div>
      					</div>
      				</div>
      				<div class="col-7 btn_container">
						<span class="access-setting">
							<span class="label">Access setting for new people:</span>
							<b-btn @click="isEditingChoosePeopleAccess = true" aria-label="choose people access">{{peopleModalAccess}}</b-btn>
					    </span>
						<div class="select-people-access" v-if="isEditingChoosePeopleAccess">
						  <b-form-group>
							<div class="select-user-section">
								<input @change="changeModalAccess('people', 'read')" v-model="accessControlMap['people'].isRead" type="checkbox" value="read" aria-label="read">
									<span class="user-role-label">read</span>
								</input>
							</div>
							<div class="select-user-section">
								<input @change="changeModalAccess('people', 'write')" v-model="accessControlMap['people'].isWrite" type="checkbox" value="write" aria-label="write">
									<span class="user-role-label">write</span>
								</input>
							</div>
							<div class="select-user-section">
								<input @change="changeModalAccess('people', 'share')" v-model="accessControlMap['people'].isShare" type="checkbox" value="share" aria-label="share">
									<span class="user-role-label">share</span>
								</input>
							</div>

							<b-btn @click="isEditingChoosePeopleAccess = false" class="ok-btn" aria-label="ok-btn">Ok</b-btn>
						  </b-form-group>
						</div>

      				</div>
      			</div>
				<div class="pagination-container">
					<div class="select-role-section">
						<b-form-group>
							<div class="role-section">
								<input @change="loadUserList" v-model="showStudents" type="checkbox" aria-label="show students"><span class="user-role-label">students</span></input>
							</div>
							<div class="role-section">
								<input @change="loadUserList" v-model="showInstructors" type="checkbox" aria-label="show instructors"><span class="user-role-label">instructors</span></input>
							</div>
						</b-form-group>
					</div>
					<div class="button-container btn_container pagination_sty3">
						<button type="button" :disabled="this.firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
						<span class="page_count" aria-hidden="true">{{ number + 1 }}</span>
						<select v-model="pageSize" @change="resetNumber" aria-label="page size" class="page_size">
							<option v-for="option in sizeOptions" v-bind:value="option">
							{{ option }}
							</option>
						</select>
					
						<button type="button" :disabled="this.lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button></div>

				</div>
      			<div class="tabel-container">
      				<table v-if="isUsersLoaded" class="table user-management-table">
      					<thead class="thead-light">
      						<tr>
      							<th class="first-column">Select</th>
      							<th class="second-column">Name</th>
      							<th class="action-column">Access</th>
      						</tr>
      					</thead>
      					<tbody v-if="formattedUserList.length > 0">
      						<tr v-for="user in formattedUserList">
      							<td class="first-column"><input v-model="user.isSelected" @change="userSelected(user)" type="checkbox" aria-label="select user"></input></td>
      							<td class="second-column">{{ user.name }}</td>
      							<td class="permission-column">{{user.access}}   </td>
      						</tr>
      					</tbody>
      					<tbody v-else class="no-result">
      						<tr>no result found </tr>
      					</tbody>
      				</table>
      			</div>
      		</div>
		   <div class="user-container-section">
			  <template v-for="user in formattedSharedWithUsers">
				<div class="user-container">
					<div id="box" class="tags">
					  <div id="content" class="tag">{{user.name}}</div>
					  <b-btn id="closeDiv" class="icon_del" @click="removeUser(user)" aria-label="remove user">
						X
					  </b-btn>
					</div>
				</div>
			  </template>
			</div>
          <!-- <b-table hover :items="formattedUserList" :fields='choosePeopleModalFields'>
            <template slot="select" slot-scope="data">
              <input @change="userSelected(data.item)" v-model="data.item.isSelected" type="checkbox"></input>
            </template>
          </b-table> -->
          <!-- Modal Footer Section -->
          <div slot="modal-footer">
            <b-button-group>
              <b-btn @click="selectPeopleCanceled" aria-label="cancel">
                cancel
              </b-btn>
              <b-btn @click="selectPeopleSaveAndNext" aria-label="save and next">
                save and next
              </b-btn>
            </b-button-group>
          </div>
      </b-modal>
    <!-- Select Groups Modal -->
    <b-modal ref="modal"
              title="Select Groups"
              v-model="showChooseGroupsModal"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close>
    <!-- Modal Content Section -->

    <!-- Modal Footer Section -->
    <div slot="modal-footer">
      <b-button-group>
        <b-btn @click="selectGroupsCanceled" aria-label="cancel">
          cancel
        </b-btn>
        <b-btn @click="selectGroupsSaveAndNext" aria-label="save and next">
          save and next
        </b-btn>
      </b-button-group>
    </div>
  </b-modal>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'

  export default {
    name: 'sharing',
    props: ['entityType', 'entityUuid'],
    components: {
    },
    data: () => {
      return {
        userId: localStorage.getItem('userid'),
        userRole: localStorage.getItem('userrole'),
        currentInstitutionId: {},
        showBaseModal: false,
        showChoosePeopleModal: false,
        showChooseGroupsModal: false,
        selectedUsers: [],
        selectedGroups: [],
        permissionOptions: [
          {text: 'read', value: 'read'},
          {text: 'write', value: 'write'},
          {text: 'share', value: 'share'}
        ],
        sizeOptions: [ 10, 50, 100 ],
        pageSize: 100,
        firstPage: true,
        lastPage: false,
        number: 0,
        totalPages: 0,
        numberOfElements: 0,
        isUsersLoaded: false,
        baseModalTableFields: ['name', 'permission', 'remove'],
        choosePeopleModalFields: ['select', 'name', 'access'],
        peopleModalAccess: 'read',
        groupModalAccess: 'read',
        name: '',
        selectedUsersSnapShot: [],
        isEditingChoosePeopleAccess: false,
        accessControlMap: {
          'people': {isRead: true, isEdit: false, isShare: false},
          'groups': {isRead: true, isEdit: false, isShare: false}
        },
        showStudents: true,
        showInstructors: true,
        originalUsers: []
      }
    },
    mounted () {
      this.loadData()
    },
    methods: {
      ...mapActions([
        'populateSharedUsers',
        'populateSharedEntity',
        'loadUsers',
        'updateUsersPermissions'
      ]),
      loadUserList () {
        let roleFilter = this.roleFilter
        this.loadUsers({parentSpaceId: this.currentInstitutionId, page: this.number, count: this.pageSize, role: roleFilter, name: this.name}).then(res => {
          this.isUsersLoaded = true
          this.firstPage = res.firstPage
          this.lastPage = res.lastPage
          this.number = res.number
          this.totalPages = res.totalPages
          this.numberOfElements = res.numberOfElements
        })
      },
      loadData () {
        let userObj = JSON.parse(localStorage.getItem('userobj'))
        this.currentInstitutionId = userObj.institutionId

        let entityUuid = this.entityUuid
        let entityType = this.computedEntityType

        if (!entityUuid || !entityUuid.length || entityUuid.length <= 0) {
          return
        }

        this.populateSharedEntity({entityType: entityType, entityUuid: entityUuid})
        this.populateSharedUsers({entityType: entityType, entityUuid: entityUuid}).then((response) => {
          let formatUser = this.formatSharedUser
          let formattedSharedUsers = []
          let sharedWithUsers = this.sharedWithUsers
          sharedWithUsers.forEach(function (user) {
            formattedSharedUsers.push(formatUser(user))
          })

          this.selectedUsers = formattedSharedUsers
          this.selectedUsersSnapShot = formattedSharedUsers
          this.originalUsers = formattedSharedUsers
        })
        this.loadUsers({
          parentSpaceId: this.currentInstitutionId,
          page: this.number,
          count: this.pageSize,
          role: 'Instructor|Student',
          name: this.name
        })
      },
      removeUser (user) {
        let userToRemove = user.userData
        let selectedUsers = this.selectedUsers

        let updatedUsers = selectedUsers.filter(function (value, index, userArray) {
          return value.userData.uuid !== userToRemove.uuid
        })
        this.selectedUsers = updatedUsers
      },
      onShown () {
      },
      getEntriesForSaving () {
        let formattedUsers = []
        let sharedUsers = this.formattedSharedWithUsers
        let formatUser = this.getNewUserWithSharingInfo

        let originalUsers = this.sharedWithUsers
        if (originalUsers.length > 0) {
          originalUsers.forEach(function (user) {
            let curr = formatUser(user)
            curr.shareAction = 'unshare'
            formattedUsers.push(curr)
          })
        }

        sharedUsers.forEach(function (obj) {
          let formattedUser = formatUser(obj)
          formattedUsers.push(formattedUser)
        })
        return formattedUsers
      },
      cancelClicked () {
        this.showBaseModal = false
      },
      saveAndDoneClicked () {
        this.originalUsers = this.selectedUsers
        let sharedUsers = this.getEntriesForSaving()
        let entityType = this.computedEntityType
        let entityUuid = this.entityUuid
        this.updateUsersPermissions({sharedUsers: sharedUsers, entityType: entityType, entityUuid: entityUuid})
        this.showBaseModal = false
      },
      selectPeopleCanceled () {
        this.selectedUsers = this.selectedUsersSnapShot
        this.showChoosePeopleModal = false
        this.showBaseModal = true
      },
      selectPeopleSaveAndNext () {
        // TODO update selected people
        this.showChoosePeopleModal = false
        this.showBaseModal = true
      },
      selectGroupsCanceled () {
        this.showChooseGroupsModal = false
        this.showBaseModal = true
      },
      selectGroupsSaveAndNext () {
        // TODO update selected groups
        this.showChooseGroupsModal = false
        this.showBaseModal = true
      },
      readClicked (user) {
        user.sharePermission = 'read'
        user.shareActions = ['read']
        user.isRead = true
        user.isWrite = false
        user.isShare = false
      },
      writeClicked (user) {
        user.sharePermission = 'write'
        user.shareActions = ['read', 'write']
        user.isRead = true
        user.isWrite = true
        user.isShare = false
      },
      shareClicked (user) {
        user.sharePermission = 'share'
        user.shareActions = ['read', 'write', 'share']
        user.isRead = true
        user.isWrite = true
        user.isShare = true
      },
      isEditingUser (user) {
        user.isEditing = true
      },
      isDoneEditingUser (user) {
        user.isEditing = false
      },
      showChoosePeopleClicked () {
        // copying to persist state changes on the first modal when the user clicks cancel on other screens
        let formattedSharedWithUsers = this.formattedSharedWithUsers
        this.selectedUsersSnapShot = formattedSharedWithUsers.slice()

        this.changeModalAccess('people', 'read')
        this.loadUserList()
        this.showChoosePeopleModal = true
        this.showPeople = true
        this.showInstructors = true
      },
      userSelected (user) {
        let selectedUsers = this.selectedUsers

        // this logic looks inverted because the checkbox v-model has already flipped "isSelected"
        if (user.isSelected) {
          user.sharePermission = this.peopleModalAccess
          selectedUsers.push(user)
        } else {
          this.removeUser(user)
        }
      },
      resetNumber () {
        this.number = 0
        this.loadUserList()
      },
      toggleUserFilterPopup () {
        this.isShowUserFilterPopup = !this.isShowUserFilterPopup
        $('.search_field').toggleClass('popover-style')
      },
      prev () {
        this.number = this.number - 1
        this.loadUserList()
      },
      next () {
        this.number = this.number + 1
        this.loadUserList()
      },
      getUserIfSelected (user) {
        let selectedUsers = this.selectedUsers
        let selectedUser = null

        selectedUsers.forEach(function (obj) {
          let currUser = obj.principal
          if (currUser.uuid === user.uuid) {
            selectedUser = obj
          }
        })
        return selectedUser
      },
      startSharingClicked () {
        this.loadData()
        this.showBaseModal = true
      },
      formatSharedUser (obj) {
        if (!obj) {
          return {}
        }
        let user = (obj.principal) ? (obj.principal) : obj
        let sharePermission = obj.sharePermission
        let shareActions = []
        let isRead = false
        let isWrite = false
        let isShare = false

        if (!sharePermission || sharePermission === 'read') {
          shareActions = ['read']
          isRead = true
        } else if (sharePermission === 'write') {
          shareActions = ['read', 'write']
          isRead = true
          isWrite = true
        } else if (sharePermission === 'share') {
          shareActions = ['read', 'write', 'share']
          isRead = true
          isWrite = true
          isShare = true
        } else {
          sharePermission = 'read'
          shareActions = ['read']
          isRead = true
        }

        let formattedUser = {
          name: user.firstName + ' ' + user.lastName,
          access: sharePermission,
          permission: sharePermission,
          sharePermission: sharePermission,
          userData: obj.principal,
          isEditing: false,
          isRead: isRead,
          isWrite: isWrite,
          isShare: isShare,
          shareActions: shareActions,
          principal: user
        }
        return formattedUser
      },
      changeModalAccess (modalType, accessType) {
        let accessControlMap = null
        if (modalType === 'people') {
          accessControlMap = this.accessControlMap['people']
          this.peopleModalAccess = accessType
        } else if (modalType === 'groups') {
          accessControlMap = this.accessControlMap['groups']
          this.groupModalAccess = accessType
        }

        if (accessType === 'read') {
          accessControlMap.isRead = true
          accessControlMap.isWrite = false
          accessControlMap.isShare = false
        } else if (accessType === 'write') {
          accessControlMap.isRead = true
          accessControlMap.isWrite = true
          accessControlMap.isShare = false
        } else if (accessType === 'share') {
          accessControlMap.isRead = true
          accessControlMap.isWrite = true
          accessControlMap.isShare = true
        }
      },
      getNewUserWithSharingInfo (user) {
        let principal = null
        let data = (user.principal) ? user.principal : user.userData
        principal = {
          'uuid': data.uuid,
          '_class': data._class,
          'eMail': '',
          'displayName': data.displayName,
          'firstname': data.firstName,
          'lastname': data.lastName,
          'shareAction': (user.isSelected) ? 'share' : 'unshare',
          'sharePermission': user.sharePermission,
          'sharePermissionText': user.sharePermission,
          'showHidePermissionDropDown': false
        }
        return {
          principal: principal,
          sharePermission: user.sharePermission,
          shareAction: (user.isSelected) ? 'share' : 'unshare'
        }
      }
    },
    computed: {
      ...mapState({
        'sharedWithUsers': state => state.sharing.sharedWithUsers,
        'sharedWithGroups': state => state.sharing.sharedWithGroups,
        'sharedEntity': state => state.sharing.sharedEntity,
        'userList': state => state.user.users.content
      }),
      computedEntityType () {
        let entityType = (this.entityType) ? this.entityType : 'entity'
        return entityType
      },
      formattedSharedEntity () {
        let sharedEntity = this.sharedEntity
        if (sharedEntity) {
          return sharedEntity
        } else {
          return {}
        }
        // return sharedEntity
      },
      formattedSharedWithUsers () {
        let formattedUsers = []
        let sharedUsers = this.selectedUsers
        let formatSharedUser = this.formatSharedUser

        sharedUsers.forEach(function (obj) {
          let formattedUser = formatSharedUser(obj)
          formattedUser.isSelected = true
          formattedUsers.push(formattedUser)
        })
        this.selectedUsers = formattedUsers
        return formattedUsers
      },
      formattedUserList () {
        let formattedUsers = []
        let allUsers = this.userList
        let userId = this.userId

        let getUserIfSelected = this.getUserIfSelected
        let formatSharedUser = this.formatSharedUser

        allUsers.forEach(function (user) {
          if (user.uuid !== userId) {
            let selectedUser = getUserIfSelected(user)
            let formattedUser = (selectedUser) ? formatSharedUser(selectedUser) : formatSharedUser(user)

            if (selectedUser) {
              formattedUser.isSelected = true
            } else {
              formattedUser.isSelected = false
              formattedUser.userData = user
              formattedUser.principal = user
              formattedUser.isRead = false
              formattedUser.shareActions = []
            }
            formattedUsers.push(formattedUser)
          }
        })
        return formattedUsers
      },
      sharedUsersForSaving () {
        let formattedUsers = []
        let sharedUsers = this.formattedSharedWithUsers
        let formatUser = this.getNewUserWithSharingInfo

        sharedUsers.forEach(function (obj) {
          let formattedUser = formatUser(obj)
          formattedUsers.push(formattedUser)
        })
        return formattedUsers
      },
      shareLink () {
        let entityType = this.computedEntityType
        let entityUuid = this.entityUuid
        let origin = window.origin
        return origin + '/' + entityType + '/' + entityUuid
      },
      sharingTextHeader () {
        let text = ''
        let selectedUsers = this.selectedUsers
        if (!selectedUsers || selectedUsers.length === 0) {
          text = 'Enter some people and/or groups to share this content with'
        } else if (selectedUsers.length === 1) {
          text = 'Sharing with only this 1 person'
        } else {
          text = 'Sharing with only these ' + selectedUsers.length + ' people'
        }
        return text
      },
      entityLabel () {
        let entityType = this.computedEntityType
        if (!entityType || entityType === 'entity') {
          return 'Stream'
        } else {
          return entityType.charAt(0).toUpperCase() + entityType.substr(1)
        }
      },
      roleFilter () {
        let filter = ''
        let showStudents = this.showStudents
        let showInstructors = this.showInstructors
        if ((showInstructors && showStudents)) { // TODO default to all?  || (!showInstructors && !showStudents)) {
          filter = 'Instructor|Student'
        } else if (showInstructors) {
          filter = 'Instructor'
        } else if (showStudents) {
          filter = 'Student'
        }
        return filter
      }
    },
    watch: {
      accessControlMap (newMap) {
        Object.keys(newMap).forEach(function (key) {
          let currentMap = newMap[key]
          currentMap['isRead'] = currentMap['isRead'] || currentMap['isWrite'] || currentMap['isShare']
          currentMap['isWrite'] = currentMap['isWrite'] || currentMap['isShare']
          currentMap['isShare'] = currentMap['isShare']
        })
      }
    }
  }
</script>

<style scoped>
.conflict {
    color: red
}

.no-conflict {
    color: green
}

.a:hover {
  color: blue;
}

#editPermissionsDropDown:hover{
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/app/sharing/components/Sharing.vue